<p-toast />
<p-blockUI class="w-screen h-screen" [blocked]="progressService.blocked | async">
    <div class="card w-screen h-screen">
        <div class="grid justify-items-center mt-12">
            <div class="card grid justify-items-center w-xl">
               <img class="mr-2" style="width:96px;height:96px" src="assets/runeandgear_logos/512hexagonlight.png" alt="Logo">
                <h4 class="mt-6">{{progressService.progressMessage | async}}</h4>
                <p-progressSpinner aria-label="Loading" /><br/> 
                <h5 class="mt-2">Please wait</h5> 
            </div>
        </div>
    </div>
</p-blockUI>

